import React from 'react';
import LegalLayout from './LegalLayout';

const SUPPORT_EMAIL = 'destek@dekosta.com';

const Terms = () => (
  <LegalLayout title="Kullanım Koşulları" lastUpdated="2026-05-24">
    <section>
      <h2 className="text-white font-semibold mb-2">1. Taraflar ve kapsam</h2>
      <p>
        Bu sözleşme, DEKOSTA uygulamasını kullanan kullanıcı ile DEKOSTA hizmet sağlayıcısı arasındadır.
        Uygulamayı kullanarak bu koşulları kabul etmiş sayılırsınız.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">2. Hizmetin tanımı</h2>
      <p>
        DEKOSTA, fiziksel ürünlere bağlı dijital koleksiyon platformudur. Kullanıcı, fiziksel kart
        üzerindeki aktivasyon kodunu uygulamada manuel girerek veya kamera + OCR ile okutarak dijital
        koleksiyon karakterleri ve eşyalar elde eder.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">3. Yaş koşulu</h2>
      <p>
        Hizmet 13 yaş ve üstü kullanıcılara yöneliktir. Kayıt sırasında 13 yaş üstünde olduğunuzu beyan
        etmeniz gerekir. 18 yaşından küçükseniz ebeveyn / vasi izni ile hizmeti kullanmanız önerilir.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">4. Hesap güvenliği</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Hesap parolanız sizin sorumluluğunuzdadır; üçüncü kişilerle paylaşmayın.</li>
        <li>Şüpheli erişim halinde derhal parolanızı değiştirin.</li>
        <li>Tek hesap kullanın; çoklu hesap yasaktır.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">5. Fiziksel kart aktivasyonu</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Aktivasyon kodu yalnız bir kez kullanıma uygundur; kullanıldıktan sonra hesabınıza bağlanır.</li>
        <li>Aktivasyon hatası halinde destek e-postasına iletişime geçin.</li>
        <li>Hesabınızı sildiğinizde sahibi olduğunuz kodlar serbest bırakılır; aynı fiziksel kart başka
          kullanıcı tarafından aktive edilebilir.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">6. Yasak davranışlar</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Aktivasyon kodlarının brute force ile tahmin edilmeye çalışılması</li>
        <li>Hesap bilgilerini paylaşma, satma veya devretme</li>
        <li>Hizmeti tersine mühendislik, scraping veya otomatik istemci ile kullanma</li>
        <li>Diğer kullanıcılara taciz veya rahatsız edici içerik gönderme</li>
        <li>Yasalara aykırı içerik paylaşımı</li>
      </ul>
      <p className="mt-2">
        Bu maddelere aykırılık halinde hesabınız uyarılmaksızın askıya alınabilir veya silinebilir.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">7. Dijital içerik niteliği</h2>
      <p>
        Aktivasyon ile elde ettiğiniz dijital koleksiyon karakterleri ve eşyalar hizmet içi kayıtlardır;
        gerçek dünya parasal değer taahhüdü içermez. Hesap silindiğinde bu içerikler erişilemez hale
        gelir.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">8. Fikri mülkiyet</h2>
      <p>
        Karakter görselleri, isimler, kart tasarımları, kod ve uygulama mimarisi DEKOSTA&apos;ya aittir.
        İzin alınmaksızın kopyalama, türetme veya ticari kullanım yasaktır.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">9. Sorumluluk reddi</h2>
      <p>
        Hizmet &quot;olduğu gibi&quot; sunulur. Sürekli erişilebilirlik, hata yokluğu veya belirli bir amaca
        uygunluk konusunda taahhüt verilmez. Uygulanabilir hukukun izin verdiği azami ölçüde DEKOSTA,
        dolaylı, arızi veya cezai zararlardan sorumlu değildir.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">10. Hesap silme</h2>
      <p>
        Profil &gt; Hesap menüsünden hesabınızı silebilirsiniz. Silme işlemi kişisel verilerinizi
        anonimleştirir; sahip olduğunuz envanter kalıcı olarak kaldırılır, aktivasyon kodları serbest
        bırakılır.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">11. Değişiklikler</h2>
      <p>
        Koşullar güncellenebilir. Esaslı değişikliklerde uygulama açılışında yeniden onay istenir;
        kullanmaya devam etmek güncel sürümün kabulü anlamına gelir.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">12. Uygulanacak hukuk</h2>
      <p>
        Bu sözleşme Türkiye Cumhuriyeti hukukuna tabidir. Uyuşmazlıklarda İstanbul Mahkemeleri ve İcra
        Daireleri yetkilidir.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">İletişim</h2>
      <p>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </section>
  </LegalLayout>
);

export default Terms;
